export enum PackageEnum {
  PRO = 'PRO',
  LITE = 'LITE',
  STANDARD = 'STANDARD',
}
